'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import Image from 'next/image'
import { FC } from 'react'

export const BirthdayInRealLife: FC = () => {
  const slides = [
    '/image/2026/03/25/Frame_88218.jpg',
    '/image/2026/03/25/Frame_88219.jpg',
    '/image/2026/03/25/Frame_88220.jpg',
    '/image/2026/03/25/Frame_88221.jpg',
    '/image/2026/03/25/Frame_88222.jpg',
    '/image/2026/03/25/Frame_88223.jpg',
    '/image/2026/03/25/Frame_88224.jpg',
    '/image/2026/03/25/Frame_88225.jpg',
    '/image/2026/03/25/Frame_88226.jpg',
    '/image/2026/03/25/Frame_88227.jpg',
    '/image/2026/03/25/Frame_88228.jpg',
    '/image/2026/03/25/Frame_88229.jpg',
    '/image/2026/03/25/Frame_88230.jpg',
    '/image/2026/03/25/Frame_88231.jpg',
  ]

  return (
    <section className='relative overflow-hidden bg-[url(https://mcdn.coolmate.me/image/2026/03/25/Frame_88217.jpg)] bg-cover bg-center py-10 md:py-16'>
      <div className='px-4 lg:px-15'>
        <div className='mb-8 flex flex-col justify-between gap-6 md:mb-12 md:flex-row md:items-center'>
          <p className='text-lg font-medium !leading-normal text-white md:text-2xl 2xl:text-[28px]'>
            Thay cho lời cảm ơn sâu sắc nhất, Coolmate &quot;đổi tên&quot;
            thương hiệu để tri ân tất cả khách hàng yêu quý đã đồng hành trên
            chặng đường 7 năm qua. Bởi vì tất cả các bạn, đều là một phần không
            thể thiếu của Coolmate.
          </p>
          <div className='flex-shrink-0 max-md:hidden'>
            <Image
              src={ImageHelper.getImageUrl('/image/2026/03/25/Asset_2_1.png')}
              alt='7th Birthday'
              width={160}
              height={80}
              className='aspect-[138/111] h-auto'
            />
          </div>
        </div>

        <Carousel
          opts={{
            align: 'start',
            loop: true,
          }}
          plugins={[
            Autoplay({
              delay: 3000,
              stopOnInteraction: false,
            }),
          ]}
          className='w-full'
        >
          <CarouselContent className='-ml-3 md:-ml-4'>
            {slides.map((slide, index) => (
              <CarouselItem
                key={index}
                className='basis-1/2 cursor-default pl-3 md:basis-1/4 md:pl-4 2xl:basis-1/5'
              >
                <div className='overflow-hidden rounded-xl'>
                  <Image
                    src={ImageHelper.getImageUrl(slide)}
                    alt={`Coolmate in Real Life ${index + 1}`}
                    width={400}
                    height={533}
                    className='aspect-[3/4] w-full object-cover transition-transform duration-500 hover:scale-110'
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </section>
  )
}
